import { createSlice } from '@reduxjs/toolkit';
import { IDictionariesState } from '../../types/features';

export const dictionariesSliceInitialState: IDictionariesState = {
  availableRegions: [],
  banks: [],
  features: [],
  lastUpdateTimestamp: 0,
  isShadowMode: false,
  sortTypes: [],
  regionId: 1,
  defaultFilters: {},
  programsSummary: [],
};

export const dictionariesSlice = createSlice({
  name: 'dictionaries',
  initialState: dictionariesSliceInitialState,
  reducers: {},
});
